export default {
    destination: 'destination',
    hotel: 'hotel'
};
